<template>
  <v-app id="inspire">
    <v-row>
        <v-col>
            <v-card fluid class="fill-height frame text-center" :to="'/questions'">
                <v-row style="margin-top:20%"><v-icon>mdi-head-question</v-icon></v-row>
                <v-card-title primary-title class="justify-center">
                    Fragen
                </v-card-title>
                <v-card-subtitle>In diesem Bereich können Fragen zur Abfrage der Process Experience erstellt werden.</v-card-subtitle>
            </v-card>
        </v-col>
        <v-col>
            <v-card fluid class="fill-height frame text-center" :to="'/surveys'">
                <v-row style="margin-top:20%"><v-icon>mdi-poll</v-icon></v-row>
                <v-card-title primary-title class="justify-center">
                    Umfragen
                </v-card-title>
                <v-card-subtitle>In diesem Bereich können neue Umfragen aus den bestehenden Fragen generiert werden.</v-card-subtitle>
            </v-card>
        </v-col>
    </v-row>
  </v-app>
</template>

<script>
export default {
  name: "ProcessExperience",
};
</script>
<style scoped>
.frame{
    border: 1px solid gray;
    height:500px;
    margin:10%;
}
.row{
    justify-content: center;
}
.v-icon{
    font-size: 128px !important;
}
</style>